<template>
  <div>
    <div class="d-flex justify-center mt-2">
      <VCard class="overallcard" style="box-shadow: none; overflow: unset">
        <div>
          <div class="searchBtn">
            <VCol cols="12" md="12" sm="12" class="track">
              <h3>Enter your tracking number</h3>
            </VCol>

            <div class="row">
              <div class="track col-md-8">
                <label>CONSIGNMENT NUMBER</label>
                <v-text-field
                  class="login-form"
                  v-model="consignmentNumber"
                  required
                  type="text"
                  :rules="validation"
                  variant="outlined"
                >
                </v-text-field>
              </div>

              <div class="d-flex align-center track col-md-4">
                <VBtn
                  color="#ed1c24"
                  class="trackbtn"
                  type="submit"
                  @click="trackingData(consignmentNumber)"
                >
                  TRACK
                </VBtn>
              </div>
            </div>
          </div>
        </div>
      </VCard>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tab: null,
      // consignmentNumber: 3000001,
      consignmentNumber: "",
      responseTrackingData: [],
      overallResponse: "",

      validation: [
        (v) => !!v || "Please enter a valid input"
      ],
    };
  },
  methods: {
    trackingData($event) {
      console.log($event, "$event");
      if($event)
      this.$router.push({
                    path: "/trackingData",
                    query: { shipping_id: $event},
                  });

    },
  },
  created() {
    let userAgentString = navigator.userAgent;
    const chromeAgent = userAgentString.indexOf("Chrome") > -1;
    const safariAgent = userAgentString.indexOf("Safari") > -1;
    console.log(chromeAgent, safariAgent, "navigator.userAgent");
  },
};
</script>

<style scoped>
.consignmentCard {
  margin-block: 120px;
  margin-block-end: 50px !important;
}

.overallcard {
  padding: 25px !important;
  border-radius: 6px;
  background-color: white !important;
  box-shadow: 2px 3px 5px rgba(0, 0, 0, 20%);
  inline-size: 100%;
}

.trackingOverallCard {
  padding: 35px !important;
  border-radius: 8px;
  inline-size: 100%;
}

.v-label {
  font-size: 17px !important;
  font-weight: 900;
}

.trackbtn {
  /* margin-block-start:25px; */
  padding-block: 10px;
  padding-inline: 30px;
}

.v-table {
  color: black !important;
}

.v-btn__content {
  color: white !important;
}

.searchBtn label {
  font-weight: 600;
}

>>> .login-form .v-field {
  height: 42px;
}
>>> .login-form .v-field__input {
  padding-top: 0;
      background: no-repeat;
}
>>>.v-text-field input:focus{
    border:none !important;
    background: none !important;
}

@media only screen and (max-width: 480px) {
  .track {
    width: 100% !important;
  }
}
</style>
